import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Panel } from "primereact/panel";
import { useReport } from "../../context/report";

export function QuebrasTempos() {
    const { data } = useReport();

    function formatNumber(rowData, props) {
        return Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 }).format(rowData[props.field]);
    }

    function formarPercent(rowData, props) {
        return Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 }).format(rowData[props.field]) + "%";
    }

    return (
        <div>
            <Panel
                collapsed
                header="RELATÓRIO DE EFICIÊNCIA E QUEBRAS POR HORA"
                toggleable
            >
                <DataTable
                    className="p-m-1"
                    emptyMessage="Nenhum resultado encontrado."
                    filterDisplay="row"
                    responsiveLayout="scroll"
                    size="small"
                    value={data.dados}
                >
                    <Column header="Turma" field="turma" filter showFilterMenu={false} sortable style={{ width: "10%" }} />
                    <Column header="Grupo" field="grupo" filter showFilterMenu={false} sortable style={{ width: "10%" }} />
                    <Column header="Data" field="dataf" filter showFilterMenu={false} sortable style={{ width: "10%" }} />
                    <Column header="Eficiência" field="eficiencia" body={formarPercent} sortable />
                    <Column header="Trama/h" field="trama_hora" sortable />
                    <Column header="Urdume/h" field="urdume_hora" sortable />
                    <Column header="Total/h" field="quebras_total" sortable />
                    <Column header="Tempos Declarados" field="tempos" sortable />
                </DataTable>
            </Panel>
            <Panel
                collapsed
                header="RELATÓRIO MÉDIO DE EFICIÊNCIA E QUEBRAS"
                toggleable
            >
                {data.grupos.map((item) => (
                    <div className="p-grid" style={{ marginBottom: 42 }}>
                        <div className="p-col-1 p-d-flex p-jc-center p-ai-center">
                            <h2 className="p-m-0 p-text-center" >G{item.grupo}</h2>
                        </div>
                        <DataTable
                            className="p-col-11"
                            emptyMessage="Nenhum registro encontrado."
                            groupRowsBy="subheader"
                            responsiveLayout="scroll"
                            size="small"
                            value={item.data}
                        >
                            <Column header="Turma" field="turma" style={{ padding: 0 }} body={(rowData) => (
                                <div className="p-p-2 p-m-0 p-text-center" style={{ backgroundColor: rowData.color, color: "#000" }}>
                                    {rowData.turma}
                                </div>
                            )} />
                            <Column header="Média Eficiência" field="eficiencia" body={formatNumber} />
                            <Column header="Média Quebras Trama/h" field="trama_hora" body={formatNumber} />
                            <Column header="Média Quebras Urdume/h" field="urdume_hora" body={formatNumber} />
                            <Column header="Média Quebras Total/h" field="quebras_total" body={formatNumber} />
                            <Column header="Tempos declarados" field="tempos" body={formatNumber} />
                        </DataTable>
                    </div>
                ))}
            </Panel>

            <Panel
                collapsed
                header="RELATÓRIO MÉDIO DE EFICIÊNCIA E QUEBRAS POR TURMA"
                toggleable
            >
                {data.turmas.map((item) => (
                    <div>
                        <h2 className="p-m-0 p-text-center">Turma {item.turma}</h2>
                        <h3 className="p-m-0 p-text-center">Eficiência: {Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(item.eficiencia)}%</h3>
                        <DataTable
                            className="p-m-1"
                            emptyMessage="Nenhum registro encontrado."
                            responsiveLayout="scroll"
                            size="small"
                            value={item.data}
                        >
                            <Column header="Grupo" field="grupo" style={{ padding: 0 }} body={(rowData) => (
                                <div className="p-p-2 p-m-0 p-text-center" style={{ backgroundColor: rowData.color, color: "#000" }}>
                                    {rowData.grupo}
                                </div>
                            )} />
                            <Column header="Eficiência" field="eficiencia" body={formatNumber} />
                            <Column header="Quebras/hora" field="quebras_total" body={formatNumber} />
                            <Column header="Tempos declarados" field="tempos" body={formatNumber} />
                        </DataTable>
                    </div>
                ))}
            </Panel>
        </div>
    )
}